'use client'
import { ApolloClient, InMemoryCache } from '@apollo/client'
const cache: InMemoryCache = new InMemoryCache()

const apiKey = process.env.NEXT_PUBLIC_THE_GRAPH_API_KEY as string
export const client = new ApolloClient({
  uri: `https://gateway.thegraph.com/api/${apiKey}/subgraphs/id/EuaLt7tFNqBQs49BSRG45zcaQrgugMRnj7rMQXAShVTe`,
  cache
})

export const blockClient = new ApolloClient({
  uri: 'https://api.studio.thegraph.com/query/106176/blocks/version/latest',
  cache
})
